var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-input-wrapper",
      class: {
        "chat-input-wrapper--note": _vm.noteMode,
        "chat-input-wrapper--quick-replies-open": _vm.showQuickReplies
      }
    },
    [
      !_vm.hideQuickReplies
        ? _c("ChatQuickReplies", {
            attrs: {
              visible: _vm.showQuickReplies,
              namespace: _vm.namespace,
              "manage-modal-key": _vm.quickRepliesManageKey
            },
            on: {
              select: _vm.onSelectQuickReply,
              close: _vm.onCloseQuickReplies
            }
          })
        : _vm._e(),
      _vm.hasReply
        ? _c("ChatReplyPreview", {
            attrs: {
              "sender-name":
                _vm.replyTo.remetente_nome || _vm.replyTo.senderName || "",
              content: _vm.replyTo.conteudo || "",
              "show-cancel": ""
            },
            on: { cancel: _vm.onCancelReply }
          })
        : _vm._e(),
      _vm.hasFile && !_vm.hideMediaUpload
        ? _c("ChatMediaUploadPreview", {
            ref: "mediaPreview",
            attrs: {
              file: _vm.selectedFile,
              progress: _vm.uploadProgress,
              caption: _vm.mediaCaption
            },
            on: {
              cancel: _vm.clearFile,
              "update:caption": function($event) {
                _vm.mediaCaption = $event
              },
              send: _vm.onSend
            }
          })
        : _vm._e(),
      _vm.noteMode
        ? _c(
            "div",
            {
              staticClass: "note-mode-banner d-flex align-center pa-2",
              attrs: { "data-test": "note-mode-banner" }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: {
                  name: _vm.icons.lockOutline,
                  size: "16",
                  color: "amber darken-3"
                }
              }),
              _vm._m(0),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Fechar modo nota interna"
                  },
                  on: { click: _vm.toggleNoteMode }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.icons.close,
                      size: "12",
                      color: "#8E8E8E"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "chat-input d-flex align-center px-4 py-3" },
        [
          !_vm.hideNoteToggle
            ? _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "mr-1",
                                  class: { "note-active": _vm.noteMode },
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "data-test": "note-toggle",
                                    disabled: _vm.disabled,
                                    "aria-label": _vm.noteMode
                                      ? "Voltar para mensagem do WhatsApp"
                                      : "Escrever nota interna",
                                    "aria-pressed": _vm.noteMode
                                      ? "true"
                                      : "false"
                                  },
                                  on: { click: _vm.toggleNoteMode }
                                },
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.noteMode
                                      ? "mdi-note-edit-outline"
                                      : "mdi-note-plus-outline",
                                    size: "20",
                                    color: _vm.noteMode
                                      ? "amber darken-3"
                                      : undefined
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    885381634
                  )
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.noteMode
                          ? "Voltar para mensagem do WhatsApp"
                          : "Escrever nota interna"
                      )
                    )
                  ])
                ]
              )
            : _vm._e(),
          !_vm.hideMediaUpload
            ? _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "data-test": "attachment-button",
                                    disabled: _vm.disabled,
                                    "aria-label": "Anexar arquivo"
                                  },
                                  on: { click: _vm.onAttachment }
                                },
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.icons.attachment,
                                    size: "20"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2383062519
                  )
                },
                [_c("span", [_vm._v("Anexar arquivo")])]
              )
            : _vm._e(),
          !_vm.hideQuickReplies
            ? _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "mr-2",
                                  class: {
                                    "quick-reply-active": _vm.showQuickReplies
                                  },
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "data-test": "quick-reply-btn",
                                    disabled: _vm.disabled,
                                    "aria-label": "Respostas rápidas",
                                    "aria-expanded": _vm.showQuickReplies
                                      ? "true"
                                      : "false"
                                  },
                                  on: { click: _vm.toggleQuickReplies }
                                },
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.icons.quickReplies,
                                    size: "20",
                                    color: _vm.showQuickReplies
                                      ? "primary"
                                      : undefined
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    678096482
                  )
                },
                [_c("span", [_vm._v("Respostas rápidas")])]
              )
            : _vm._e(),
          !_vm.hideMediaUpload
            ? _c("input-by-type", {
                key: _vm.fileInputId + "-" + _vm.fileInputKey,
                staticClass: "d-none",
                attrs: { type: "file", "id-input": _vm.fileInputId },
                on: { "add-file": _vm.onFileSelected }
              })
            : _vm._e(),
          _c("input-by-type", {
            ref: "textInput",
            staticClass: "chat-input__field flex-grow-1",
            attrs: {
              type: "text",
              "data-test": "message-input",
              placeholder: _vm.inputPlaceholder,
              "aria-label": "Digite uma mensagem",
              disabled: _vm.disabled || _vm.hasFile,
              "hide-details": "",
              outlined: "",
              "single-line": ""
            },
            nativeOn: {
              keydown: function($event) {
                return _vm.onKeydown($event)
              },
              keyup: function($event) {
                return _vm.onKeyup($event)
              },
              paste: function($event) {
                return _vm.onPaste($event)
              },
              focus: function($event) {
                return _vm.$emit("focus")
              }
            },
            model: {
              value: _vm.messageText,
              callback: function($$v) {
                _vm.messageText = $$v
              },
              expression: "messageText"
            }
          }),
          _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: {
                icon: "",
                small: "",
                "data-test": "send-button",
                disabled: _vm.sendDisabled || _vm.sending,
                "aria-label": _vm.sending
                  ? "Enviando mensagem"
                  : "Enviar mensagem",
                "aria-busy": _vm.sending ? "true" : "false"
              },
              on: { click: _vm.onSend }
            },
            [
              _vm.sending
                ? _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: "20",
                      width: "2",
                      color: "primary"
                    }
                  })
                : _c("icon-svg", {
                    attrs: {
                      name: _vm.icons.send,
                      size: "20",
                      color: _vm.sendDisabled ? "grey" : "primary"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "az-text-small flex-grow-1" }, [
      _c("strong", [_vm._v("Nota interna")]),
      _vm._v(" — só o time vê, não vai pro WhatsApp do cliente. ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }